import LandingPageForm from '../components/LandingPageForm';

export default function PasadenaLandingPage() {
  return (
    <LandingPageForm 
      cityName="Pasadena"
      neighborhood="Pasadena"
      sourceTag="qr-pasadena-mailer"
    />
  );
}
